import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { contactMethodsDataSource } from 'infrastructure/data-sources/contact-methods';

import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';
import type { IContactMethodItem } from 'infrastructure/data-sources/contact-methods';

type Options = IBaseSelectBoxOption<
  IContactMethodItem['id'],
  IContactMethodItem
>[];

interface IContactMethodSelectBoxProps
  extends Omit<IBaseSelectBoxProps, 'options'> {}

const ContactMethodSelectBox: React.FC<IContactMethodSelectBoxProps> = (
  props,
) => {
  const dataSource = useMemo(() => contactMethodsDataSource(), []);

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
        record: el,
      })),
    [dataSource],
  );

  return <BaseSelectBox options={options} {...props} />;
};

export default ContactMethodSelectBox;
